import { ComponentsOverrides, Theme } from "@mui/material";
import { InternalThemeConfig } from "../../config";

const buttonGroup = ({ palette, spacing }: InternalThemeConfig): ComponentsOverrides<Theme>["MuiButtonGroup"] => ({
    root: {
        display: "flex",
        background: `linear-gradient(155deg, ${palette.veryDarkBlue}, ${palette.darkBlue})`,
        padding: spacing(0.5),
        width: "100%",
    },
    grouped: {
        flex: 1,
    },
    groupedOutlinedHorizontal: {
        borderRadius: `${spacing(0.5)} !important`,
    },
});

export default buttonGroup;
